export const OPEN_TICKET_COMMENT_MODAL = "OPEN_TICKET_COMMENT_MODAL";
export const CLOSE_TICKET_COMMENT_MODAL = "CLOSE_TICKET_COMMENT_MODAL";
export const OPEN_TICKET_TAKEOVER_MODAL = "OPEN_TICKET_TAKEOVER_MODAL";
export const CLOSE_TICKET_TAKEOVER_MODAL = "CLOSE_TICKET_TAKEOVER_MODAL";
